import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ish-accordion-item',
  templateUrl: './accordion-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionItemComponent {
  @Input() heading: string;
  @Input() dataTestingId: string;
  @Input() isCollapsed: boolean;

  toggleCollapse() {
    // eslint-disable-next-line ish-custom-rules/no-assignment-to-inputs
    this.isCollapsed = !this.isCollapsed;
  }
}
